var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5486 9.78543C12.6493 9.6812 12.705 9.54161 12.7037 9.39671C12.7024 9.25181 12.6443 9.1132 12.5419 9.01074C12.4394 8.90828 12.3008 8.85016 12.1559 8.8489C12.011 8.84764 11.8714 8.90334 11.7672 9.00401L7.73684 13.0343L5.91702 11.2145C5.81279 11.1139 5.6732 11.0582 5.5283 11.0594C5.3834 11.0607 5.24479 11.1188 5.14233 11.2213C5.03987 11.3237 4.98175 11.4623 4.98049 11.6072C4.97923 11.7521 5.03493 11.8917 5.1356 11.996L7.73684 14.5972L12.5486 9.78543Z",
    fill: "#58E866"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4741 5.52632V17.1316C15.4741 17.5713 15.2994 17.993 14.9885 18.3039C14.6776 18.6148 14.2559 18.7895 13.8162 18.7895H3.86883C3.42913 18.7895 3.00744 18.6148 2.69652 18.3039C2.38561 17.993 2.21094 17.5713 2.21094 17.1316V1.65789C2.21094 1.21819 2.38561 0.796502 2.69652 0.485586C3.00744 0.174671 3.42913 0 3.86883 0H9.94778L15.4741 5.52632ZM9.94778 6.07895C9.80121 6.07895 9.66065 6.02072 9.55701 5.91709C9.45337 5.81345 9.39515 5.67288 9.39515 5.52632V1.10526H3.86883C3.72227 1.10526 3.5817 1.16349 3.47806 1.26713C3.37442 1.37076 3.3162 1.51133 3.3162 1.65789V17.1316C3.3162 17.2781 3.37442 17.4187 3.47806 17.5224C3.5817 17.626 3.72227 17.6842 3.86883 17.6842H13.8162C13.9628 17.6842 14.1033 17.626 14.207 17.5224C14.3106 17.4187 14.3688 17.2781 14.3688 17.1316V6.07895H9.94778ZM10.5004 2.11547L13.3586 4.97368H10.5004V2.11547Z",
    fill: "#ACACAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10526 3.3158V18.2368C1.10526 18.6765 1.27993 19.0982 1.59085 19.4092C1.90176 19.7201 2.32346 19.8947 2.76316 19.8947H13.2632V21H2.76316C2.03032 21 1.3275 20.7089 0.80931 20.1907C0.291118 19.6725 0 18.9697 0 18.2368V3.3158H1.10526Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckNote);
export default __webpack_public_path__ + "static/media/checkNote.a1bcf5aa9794e618de1033cb3fd33b6d.svg";
export { ForwardRef as ReactComponent };